import React from 'react';
import { FontWeight, TypographyName } from '@doveit/lego';
import { TextAlign } from '../../../types';
import Markdown from '../../markdown/Markdown';
import * as styles from '../PageSection.style';

export interface PageSectionDescriptionProps {
  text?: string,
  size?: TypographyName,
  textAlign?: TextAlign,
  fontWeight?: FontWeight,
  color?: string,
}

const PageSectionDescription: React.FC<PageSectionDescriptionProps> = ({
  textAlign = TextAlign.LEFT,
  size = TypographyName.BODY,
  fontWeight = FontWeight.LIGHT,
  color = 'neutrals.darkest',
  text,
}) => (
  <div
    css={styles.description}
    $textAlign={textAlign}
    $size={size}
    $color={color}
    $fontWeight={fontWeight}
  >
    <Markdown>
      {text}
    </Markdown>
  </div>
);

export default PageSectionDescription;
